import React from "react";
import { Product } from "../types";
import { cloneNode } from "../ui-script/utils";

const NoProductsFound = () => (
  <div className="col-[1/-1] flex flex-col items-center justify-center px-4 py-12">
    <div className="hp-text-center">
      <h3 className="hp-mt-2 hp-text-lg hp-font-medium hp-text-gray-900">
        No products found
      </h3>
      <p className="hp-mt-1 hp-text-sm hp-text-gray-500">
        Try adjusting your filters or search criteria
      </p>
    </div>
  </div>
);

interface ProductListProps {
  products: Product[];
  isLoading: boolean;
  existingNode: HTMLElement;
  existingProduct: any;
}

const ProductList: React.FC<ProductListProps> = ({
  products,
  existingNode,
  existingProduct,
}) => {
  if (!products || products.length === 0) {
    return <NoProductsFound />;
  }

  if (!existingNode || !existingProduct) {
    console.error("Missing required node or product data");
    return <NoProductsFound />;
  }

  return products.map((product) => {
    if (!product) return null;

    try {
      const newNode = cloneNode(existingNode, product, existingProduct);
      if (!newNode) return null;

      return (
        <div
          key={product.id}
          dangerouslySetInnerHTML={{ __html: newNode.outerHTML }}
        />
      );
    } catch (error) {
      console.error("Error cloning node:", error);
      return null;
    }
  });
};

export default ProductList;
